export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-Etumatkalla-podcast.ec2c1001.jpg";